/**
 * Сервис для хранения данных динамических полей в приложении
 * @package DynamicFieldClass
 * @version 1.0
 * @author BOLOTOV I.P.
 * @since 17.08.2022
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
import {FieldConfig} from '../../../../../modules/dynamic-fields/field.interface';
import {FormGroup} from '@angular/forms';
import {IDynamicFieldServiceInterface} from '../interfaces/DynamicFieldServiceInterface';
import {Injectable} from '@angular/core';
@Injectable()
/** Сервис для хранения данных динамических полей в приложении */
export abstract class DynamicFieldService implements IDynamicFieldServiceInterface{
    /** Конфигурации динамического поля */
    field: FieldConfig;
    /** Элемент формы, к которому принадлежит динамическое поле */
    group: FormGroup;
}
